import { Fragment } from "react";
import { observer } from 'mobx-react'
import { makeStyles, Theme, createStyles } from "@material-ui/core";
import { FlowRunner } from "../../components/FlowRunner";
import Footer from "../../../../components/Shared/Footer";
import { adminInvitationFlow } from "../data/AdminInvitationFlowDefinition";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            position: 'relative'
        },
    })
);

const AdminInvitationFlow = observer(() => {

    /********* React hooks *********/

    const classes = useStyles();

    /********* Render *********/

    return (
        <Fragment>
            <div className={classes.root}>
                <FlowRunner flow={adminInvitationFlow} />
            </div>
            <Footer />
        </Fragment >
    );
});

export default AdminInvitationFlow;